// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.noGeometryMessage {
    text-align: center;
}

.noGeometryMessage__icon--primary {
    color: var(--public-portal-primary);
}
`, "",{"version":3,"sources":["webpack://./src/components/noGeometryMessage/NoGeometryMessage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;AACvC","sourcesContent":[".noGeometryMessage {\n    text-align: center;\n}\n\n.noGeometryMessage__icon--primary {\n    color: var(--public-portal-primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
